/**
 * Created by Christof Sander on 27.09.2016.
 */

const utils = require('frontend-controller/lib/utils')

module.exports = {
	extends: [
		'/',
		'base',
		'treesManagement',
		'trees'
	],

	config: {
		treeTypeComponents: {
			default: [
				'/',
				'templates',
				'clientTrees',
				'clientTree'
			]
		}
	},

	methods: {
		showInsert: function(baseActionKey, buttonContext, buttonMode, actionBossComponent){
			if(this.actions[baseActionKey]){
				var action;
				if(buttonContext === 'database'){
					var clientData = this.getSelectedNodeData();
					action = this.prepareAction(baseActionKey, undefined, undefined, {
						source: {
							load: {
								componentData: {
									actions: {
										loadContent: {
											source: {
												load: {
													componentData: {
														model: {
															dirtyFields: {
																data: {
																	attributes: {
																		clientID: clientData.clientID
																	}
																}
															}
														}
													}
												}
											}
										}
									}
								}
							}
						}
					});
				}
				else {
					action = this.prepareAction(baseActionKey);
				}
				return this.performAction(action);
			}
			return utils.promise.reject();
		},

		sanitizeResources: function(){
			var self = this;
			var resources = {
				initialized: false,
				trees: [
					{
						name: 'Klienten...',
						tree: [],
						nodes: {}
					}
				]
			};
			var tree = resources.trees[0].tree;
			var nodes = resources.trees[0].nodes;
			var additionalClasses;

			if(this.resourceData.data && !this.resourceData.initialized) {
				this.resetNodeMappings();
				resources.initialized = true;

				// insert client
				utils.forEach(this.resourceData.data, function (client) {

					var primaryKey  = client.attributes[client.primaryKey];
					var clientIndex = self.transformIDToIndex(primaryKey, 'client', 0, tree.length);

					additionalClasses = '';
					if(client.attributes.status && client.attributes.status === 'locked'){
						additionalClasses = 'state_preview';
					}
					else if(client.attributes.status && client.attributes.status === 'inactive'){
						additionalClasses = 'state_inactive';
					}

					tree.push({
						id: clientIndex,
						parent: '#',
						text: client.attributes.name,
						type: 'client',
						state: {
							opened: true,
							disabled: false,
							selected: false
						},
						li_attr: {},
						a_attr: {
							class: additionalClasses
						}
					});
					nodes[clientIndex] = client.attributes;
					nodes[clientIndex]._primaryKey = primaryKey;

					utils.forEach(client.children.s_databases.data, function (database) {
						var primaryKey  = database.attributes[database.primaryKey];
						var databaseIndex = self.transformIDToIndex(primaryKey, 'database', 0, tree.length);

						tree.push({
							id: databaseIndex,
							parent: clientIndex,
							text: database.attributes.name,
							type: 'database',
							state: {
								opened: true,
								disabled: false,
								selected: false
							},
							li_attr: {},
							a_attr: {}
						});
						nodes[databaseIndex] = database.attributes;
						nodes[databaseIndex]._primaryKey = primaryKey;
					});
				});

				this.resourceData = resources;
			}
		},

		/**
		 * support multiple action forms.
		 *
		 * @param data      {} - onTreeAction trigger context
		 */
		onTreeAction: function (data) {
			var self = this;

			// TODO: CLEANUP
			// console.log('categoryTrees - onTreeAction', data, this.model.states);
			var actionFormsSelector = '.base_treesManagement_actionsForm';

			switch (data.onTreeActionOptions.eventType) {
				case 'move_node.jstree':
					var moveEntry = data.onTreeActionOptions.eventData.node;
					var moveEntryContext = this.getNodeContext(moveEntry.id);
					var actionKey = data.onTreeActionOptions.operation  + '_' + moveEntryContext;
					if(this.actions[actionKey]){
						var moveNode = this.getNodeData(moveEntry.id);
						var newInParentPosition = data.onTreeActionOptions.eventData.position;
						var newParentEntry, newParentNode;
						var movementAttributes;
						if(moveEntry.parent && moveEntry.parent != '#'){
							newParentEntry = this.getNode(moveEntry.parent);
							newParentNode = this.getNodeData(moveEntry.parent);
						}

						if(moveEntryContext === 'database'){
							if(newParentNode){
								movementAttributes = {
									clientID: newParentNode.clientID
								};
							}
						}

						if(movementAttributes){
							this.performAction(
								this.prepareAction(actionKey, moveNode._primaryKey, undefined, {
									source: {
										submit: {
											data: {
												data: {
													attributes: movementAttributes
												}
											}
										}
									}
								})
							).then(function(){
								// refresh to get the lists up to date after movement
								self.refreshTrees();
							}).fail(function(error){
								// prevent wrong gui state from being displayed
								self.refreshTrees();
							});
						}
						else {
							self.refreshTrees();
							throw new Error('NO MOVEMENT ATTRIBUTES FOUND: ' + actionKey + ', ' + moveEntryContext);
						}
					}
					else {
						self.refreshTrees();
						throw new Error('ACTION NOT FOUND: ' + actionKey);
					}

					break;

				case 'select_node.jstree':
					// TODO: impl. animation and animation-delay
					// show page actions if necessary
					this.$.find(actionFormsSelector).hide();
					var selector = '.clientTreesActions';
					if(data.onTreeActionOptions.eventData.node.type === 'database') selector = '.clientTreesDatabaseActions';
					this.$.find(selector).show();
					break;

				case 'deselect_node.jstree':
					// hide page actions if necessary
					this.$.find(actionFormsSelector).hide();
					break;
			}
		}
	},

	hooks: {
		onDecision: function($element, options){
			var self = this;

			switch(options.decisionType){
				case 'submit':
					switch(options.decisionComponent.componentClass) {
						case 'base_modal_modal':
						case 'templates_modal_modal':
							var modalContentComponent = options.decisionComponent.actions.loadContent.source.load.component;
							if(
								modalContentComponent &&
								(
									modalContentComponent.hasClass('templates_propertiesForms_clientPropertiesForm')
									||
									modalContentComponent.hasClass('templates_propertiesForms_databasePropertiesForm')
								)
							){
								modalContentComponent.submit().then(function(context){
									options.decisionComponent.hide();
								});
							}
							break;
					}
					break;

				case 'cancel':
					switch(options.decisionComponent.componentClass) {
						case 'base_modal_modal':
						case 'templates_modal_modal':
							options.decisionComponent.hide();
							break;
					}
					break;

				default:
				// TODO: ERROR;
			}
		}
	},

	handlers: [
		{
			name: 'afterCancel',
			componentClass: 'templates_propertiesForms_clientPropertiesForm',
			handle: function(callerComponent){
				this.deselectActiveNode();
			}
		},
		{
			name: 'onSubmitDone',
			componentClass: 'templates_propertiesForms_clientPropertiesForm',
			handle: function(callerComponent, nodeData, insertPerformed){
				if(insertPerformed){
					this.config.readyNodeID       = nodeData.data.attributes[nodeData.data.primaryKey];
					this.config.readyNodeContext  = 'client';
					callerComponent.destroy();
				}

				this.refreshTrees();
			}
		},
		{
			name: 'afterCancel',
			componentClass: 'templates_propertiesForms_databasePropertiesForm',
			handle: function(callerComponent){
				this.deselectActiveNode();
			}
		},
		{
			name: 'onSubmitDone',
			componentClass: 'templates_propertiesForms_databasePropertiesForm',
			handle: function(callerComponent, nodeData, insertPerformed){
				if(insertPerformed){
					this.config.readyNodeID       = nodeData.data.attributes[nodeData.data.primaryKey];
					this.config.readyNodeContext  = 'database';
					callerComponent.destroy();
				}

				this.refreshTrees();
			}
		}
	]
};
